import type { EventOccurrence, EventType, Person } from "@shared/types";
import type { ParticipantBadge } from "@/components/ParticipantBadges";

/** The event's primary color — driven by its type (Game, Practice, Refereeing, …), not who's
 * attending. Type answers "what kind of commitment is this," which is what a busy week's
 * color-coding needs to convey at a glance; who's involved is shown separately via a small
 * initial badge per participant (see participantBadges below), so both facets stay legible
 * instead of one color trying to mean two different things. */
export function occurrenceColor(occurrence: EventOccurrence, eventTypesById: Map<string, EventType>): string {
  return eventTypesById.get(occurrence.eventTypeId)?.color ?? "#6B7280";
}

/** Each participant's initial + color, in a stable order, for rendering small ID badges. */
export function participantBadges(occurrence: EventOccurrence, peopleById: Map<string, Person>): ParticipantBadge[] {
  return occurrence.participantIds
    .map((id) => peopleById.get(id))
    .filter((p): p is Person => Boolean(p))
    .map((p) => ({ initial: p.initial, color: p.color }));
}
